import { memo } from 'react';
import { useSelector } from 'react-redux';
import type { ProdutoCatalogo } from '@/api';
import type { RootState } from '@/store';
import CardProduto from './card-produto';
import { quantidadeNoCarrinho } from './use-carrinho-kiosk';

interface CardKioskProps {
  produto: ProdutoCatalogo;
  cor: string | null;
  aoAdicionar: (produto: ProdutoCatalogo) => void;
  aoRemover: (produto: ProdutoCatalogo) => void;
  seletorCompacto?: boolean;
  aoAbrirDetalhes?: (produto: ProdutoCatalogo) => void;
  detalhesNaFoto?: boolean;
}

function CardKiosk({ produto, cor, aoAdicionar, aoRemover, seletorCompacto, aoAbrirDetalhes, detalhesNaFoto }: CardKioskProps): JSX.Element {
  const quantidade = useSelector((s: RootState) => quantidadeNoCarrinho(s.carrinho.itens, produto.id));

  return (
    <CardProduto
      produto={produto}
      cor={cor}
      quantidade={quantidade}
      onAdicionar={aoAdicionar}
      onRemover={aoRemover}
      seletorCompacto={seletorCompacto}
      onAbrirDetalhes={aoAbrirDetalhes}
      detalhesNaFoto={detalhesNaFoto}
    />
  );
}

export default memo(CardKiosk);
